/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */

import React from 'react';
import QRCode from 'qrcode.react'

const ProjectorControl = (props) => {
  const {
    onPrev, onNext, onToggleAutoplay, url,
  } = props
  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        <button className="button" onClick={() => onPrev()}>&lt;</button>
        <button className="button" onClick={() => onToggleAutoplay()}>||</button>
        <button className="button" onClick={() => onNext()}>&gt;</button>
      </div>
      <div style={{ padding: '10px' }} >
        <a href={`${url}`} target="_new" >
          <QRCode value={`${url}`} size={80} padding={10} />
        </a>
      </div>
    </div>
  )
}

export default ProjectorControl



// WEBPACK FOOTER //
// ./src/components/projector/ProjectorControl.js